<ndt-account-device-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [devicePrivileges]="devicePrivileges$ | async"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (resetHackedAndFraud)="onResetHackedAndFraud($event)"
   (rebootPhone)="onRebootPhone($event)"
   (resetPhoneZtp)="onResetPhoneZtp($event)"
   (deviceReleased)="onDeviceReleasedToSystem($event)"
   (releaseToAccount)="onReleaseToAccount($event)"
   (deleteDevice)="onDeleteDevice($event)"
   (hideUsedDevicesChange)="onHideUsedDevicesChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-account-device-register-view>
